/**
 * Replace the auto generated anchor links
 * from WordPress with more appropriate <h2> tags.
 */
const handleMenuFooterLinks = () => {
  const menuFooterLinks = document.getElementById( 'menu-footer-links' )
  if ( menuFooterLinks ) {
    const anchorsToReplace = menuFooterLinks.querySelectorAll( '.menu-item-has-children > a[href="#"]' )
    anchorsToReplace.forEach( anchor => {
      const heading = document.createElement( 'h2' )
      heading.textContent = anchor.textContent
      const parent = anchor.closest( '.menu-item-has-children' )
      if ( parent ) {
        parent.prepend( heading )
        anchor.remove()
      }
    } )
  }
}

export default handleMenuFooterLinks